import { useState } from "react";

import chevronDown from "../../icons/chevron-down.svg";
import styles from "./dropdown.module.css";

export default function Dropdown({ children, title }) {
    const [isShown,setIsShown] = useState(false);

    return (
      <div className={styles.container}>
        <div className={styles.header} onClick={() => setIsShown(!isShown)} >
            <img src={chevronDown} style={{ transform: isShown ? "rotate(180deg)" : "none" }}/>
            <span className={styles.title}>{title}</span>
        </div>
        <div className={styles.body} style={{ display: isShown ? "block" : "none" }}>
            {children}
        </div>
      </div>
    )
}